import { createTheme } from '@mui/material/styles';

// Define the color palette based on your App.css colors
const palette = {
  primary: {
    main: '#646cff',
    light: '#9e9eff',
    dark: '#535bf2',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#4caf50',
    light: '#6fbf73',
    dark: '#3b873e',
    contrastText: '#ffffff',
  },
  background: {
    default: '#242424',
    paper: '#1a1a1a',
  },
  text: {
    primary: 'rgba(255, 255, 255, 0.87)',
    secondary: '#aaa',
  },
  divider: 'rgba(255, 255, 255, 0.08)',
};

// Create the theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    ...palette,
  },
  typography: {
    fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif',
    h4: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    // Style overrides for specific components
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(30, 30, 40, 0.7)',
          backdropFilter: 'blur(10px)',
          borderColor: 'rgba(255, 255, 255, 0.1)',
          borderWidth: 1,
          borderStyle: 'solid',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 20,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: palette.primary.main,
            '&:hover': {
              backgroundColor: palette.primary.dark,
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(30, 30, 45, 0.4)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

// Add custom gradient text function
theme.typography.gradient = {
  background: 'linear-gradient(45deg, #646cff, #9e9eff)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 600,
};

// Extend the TypographyVariants and TypographyPropsVariantOverrides interfaces
declare module '@mui/material/styles' {
  interface TypographyVariants {
    gradient: React.CSSProperties;
  }
  
  interface TypographyVariantsOptions {
    gradient?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    gradient: true;
  }
}

export default theme;